import React from 'react'
import { Route,Redirect } from 'react-router-dom'

const MatchAuthenticated = ({
	path,
	location,
	isAuthenticated,
	willAuthenticate,
	component: Component,
}: Props) =>
{
	if (isAuthenticated && !willAuthenticate){
		return( 
			<Route
				path={path}
				render={(props) => { 
					  if (typeof window.ga === 'function') {
						    window.ga('set', 'page',  location.pathname + location.search)
						    window.ga('send', 'pageview')
  					}
					return <Component {...props}/> }
				}
			/>
	
		)
	} 	
	else if(!isAuthenticated && !willAuthenticate){
		return <Redirect to={{ pathname: '/login' }} />
	}
	else return null

} 
	
export default MatchAuthenticated
